import React, {Component} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import ExchangePlanning from "./ExchangePlanning";
import {EXCHANGE_TIRES, EXCHANGE_WHEELS} from "../WheelsExchangeUtils";
import queryString from 'query-string';

class ExchangeManagement extends Component {

  render() {

    const {search} = this.props.location;
    const params = queryString.parse(search);
    const {wday, tday, windex, tindex}  = params;

    return (
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              <FormattedMessage id="page.exchange-management" />
            </h1>
          </div>
        </header>

        <div className="main__content">
          <div className="section">
            <ExchangePlanning day={wday} index={windex} type={EXCHANGE_WHEELS} />
          </div>
          <div className="section">
            <ExchangePlanning day={tday} index={tindex} type={EXCHANGE_TIRES} />
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(ExchangeManagement);
